/* eslint-disable no-unused-expressions */

import { Table, Pagination } from "antd";
import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { base_url } from "../../../base_urls";
import { getHolidayList } from "api/services/leave";
import { formatDateHandler2 } from "utils/common";
import { useSearchParams, useNavigate } from 'react-router-dom';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import { SkeltonLoader } from "components/skeltonLoader";
import { Button } from "components/Button";

import { useMediaQuery } from "react-responsive";

const Holidays = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [view, setView] = useState(isMobile? "grid":"list")

  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})

  useEffect(() => {
    getHolidayList().then(response=>{
      setHolidays(response.data.results)
    })
  }, [pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters]);



  const columns = [
    // {
    //   title: "#",
    //   dataIndex: "id",
    //   render: (text) => <span>{text}</span>,
    //   sorter: (a, b) => a.id - b.id,
    // },
    {
      title: "Title",
      dataIndex: "name",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => true,
    },
    {
      title: "HolidayDate",
      dataIndex: "date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,
      sorter: (a, b) => true,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => <span>{text}</span>,
      // sorter: (a, b) => a.Day.length - b.Day.length,
    },
    // {
    //   title: "Action",
    //   render: () => (
    //     <div className="dropdown dropdown-action ">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit_holiday"
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link>
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#delete"
    //         >
    //           <i className="fa-regular fa-trash-can m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    //   sorter: true,
    // },
  ];
  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }

  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    // setSearchParams({
    //     size: pageData?.pageSize,
    //     page: pageData?.page,
    //     sort_by: pageData?.sortBy || "",
    //     sort_type: pageData?.sortType || ""
    // })
    setPageSettings(pageData)
  };
  

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {holidays.map((holiday, index) => (
           
           <div
              className="col-md-6 col-sm-1 col-12 col-lg-3 col-xl-4"
              key={holiday.id}
            >
              <div className="profile-widget">
               
                <div className="row" >
                  {/* <div className="col-4" >
                  <div className="profile-img">
                    <a   className="avatar">
                   
                      <Image  src={holiday?.image} type="user" alt="User Image"/>
                    </a>
                  </div>
                  
                  </div> */}
                 
                  <div  className="col-8" >
                  <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                  <a 
                  // to={`/profile/${employee.id}`}

                  >
                    {holiday.name} 
                  </a>
                </h4>
                <div className="small text-muted text-start">{formatDateHandler2(holiday?.date)}</div>

              
                  </div>
                  
                    </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Holidays"
            title="Dashboard"
            subtitle="Holidays"
            modal="#add_holiday"
            name="Add Holiday"
            view={view}
            setView={setView}
          />
          <div className="d-flex justify-content-end align-items-end" >

          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              {
                view == "grid" ?
                <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
            :
            <div className="table-responsive">
            <Table
            // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                className="table-striped"
                columns={columns}
                dataSource={holidays}
                rowKey={(record) => record.id}
                loading={loading}
                pagination={{
                  total: pageSettings?.total,
                  pageSize: pageSettings?.pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: pageSizeOptions,
                  // showQuickJumper: true,
                  itemRender: itemRender,
                  position: "right",
                  current: pageSettings?.page,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`,
                }}
                onChange={handleChange}
              />
            </div>

              }
             
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      <AddHoliday />
      <DeleteModal Name="Delete Holiday" />
    </>
  );
};

export default Holidays;
